import React from "react";

import i18next from "../../../i18n"
import { strUcFirst } from "../../../utils/index";

interface BasicDetailsProps {
  chatUserDetails: any;
}
const BasicDetails = ({ chatUserDetails }: BasicDetailsProps) => {
  const fullName = chatUserDetails.first_name
    ? `${chatUserDetails.first_name} ${chatUserDetails.last_name}`
    : "-";

  return (
    <div className="pb-2">
      <h5 className="font-size-11 text-uppercase mb-2">{strUcFirst(i18next.t('pages.dashboard.user_profile_details.info'))} :</h5>
      <div>
        <div className="d-flex align-items-end">
          <div className="flex-grow-1">
            <p className="text-muted font-size-14 mb-1">{strUcFirst(i18next.t('form.full_name'))}</p>
          </div>
          <div className="flex-shrink-0">
            <button type="button" className="btn btn-sm btn-soft-primary">
            {strUcFirst(i18next.t('button.edit'))}
            </button>
          </div>
        </div>
        <h5 className="font-size-14">{fullName}</h5>
      </div>

      <div className="mt-4">
        <p className="text-muted font-size-14 mb-1">{strUcFirst(i18next.t('form.phone'))}</p>
        <h5 className="font-size-14">
          {chatUserDetails.phone ? "+"+chatUserDetails.phone : "-"}
        </h5>
      </div>

      <div className="mt-4">
        <p className="text-muted font-size-14 mb-1">{strUcFirst(i18next.t('form.email'))}</p>
        <h5 className="font-size-14">
          {chatUserDetails.email ? chatUserDetails.email : "-"}
        </h5>
      </div>

      <div className="mt-4">
        <p className="text-muted font-size-14 mb-1">{strUcFirst(i18next.t('form.location'))}</p>
        <h5 className="font-size-14 mb-0">
          {chatUserDetails.location ? chatUserDetails.location : "-"}
        </h5>
      </div>
    </div>
  );
};

export default BasicDetails;
